import { ErrorBoundary } from '@sentry/react';
import { FC, Suspense } from 'react';

import { SettingsPageFrame } from '@eluve/blocks';
import {
  LoadingIndicator,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@eluve/components';
import { useTranslation } from '@eluve/i18n';
import { useIsFeatureFlagEnabled } from '@eluve/smart-blocks';

import { MembersFhirView } from './MembersFhirView';
import { UsersList } from './UsersList';

export const UsersPage: FC<{}> = () => {
  const { t } = useTranslation();
  const medplumEnabled = useIsFeatureFlagEnabled('MEDPLUM');

  return (
    <SettingsPageFrame size="wide" title={t('tenantAdmin.users.membersTitle')}>
      <ErrorBoundary
        fallback={<div>{t('tenantAdmin.common.thereWasAnError')}</div>}
      >
        <Suspense fallback={<LoadingIndicator size="xl" />}>
          {medplumEnabled ? (
            <Tabs defaultValue="classic">
              <TabsList className="mb-4">
                {/* Deliberately untranslated: "Classic" pairs with the FHIR
                    proper noun and both are admin-facing terms. */}
                <TabsTrigger value="classic">Classic</TabsTrigger>
                <TabsTrigger value="fhir">FHIR</TabsTrigger>
              </TabsList>
              <TabsContent value="classic">
                <UsersList />
              </TabsContent>
              <TabsContent value="fhir">
                <MembersFhirView />
              </TabsContent>
            </Tabs>
          ) : (
            <UsersList />
          )}
        </Suspense>
      </ErrorBoundary>
    </SettingsPageFrame>
  );
};
